import { render, staticRenderFns } from "./modify-psw.vue?vue&type=template&id=156f2bf6&scoped=true&"
import script from "./modify-psw.vue?vue&type=script&lang=js&"
export * from "./modify-psw.vue?vue&type=script&lang=js&"
import style0 from "./modify-psw.vue?vue&type=style&index=0&id=156f2bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f2bf6",
  null
  
)

export default component.exports